import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from '../Layout/ChatContext';

const TopicViewer = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const {isChatVisible, toggleChat, showChat } = useChat();

    // Retrieve baseTopicLink from state passed via navigate
    const baseTopicLink = location.state?.baseTopicLink;


    const handleBackClick = () => {
        navigate(-1); // Navigate back to the previous page
    };

    if (!baseTopicLink) {
        return <div>No Topic Link available</div>;
    }

    return (
        <div>
            {/* Back Button */}
            <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={handleBackClick}>
                    <span>
                        <i className="bi bi-chevron-left"></i> {t('backbutton')}
                    </span>
                </button>
                <h2 className="page-heading">&nbsp;</h2>
            </div>
                    <iframe
                        src={baseTopicLink}
                        title="Child Development Topic"
                        style={{ width: "100%", height: "80vh", border: "none" }}
                    />
                    {/* {isChatVisible && <ChatBotWindow />} */}
        </div>
    );
};

export default TopicViewer;
